import {
  ColumnFilterElementTemplateOptions,
  ColumnProps,
} from 'primereact/column';

import { TableDropdownFilter } from '@/components';
import { TableData } from '@/components/Table/types';
import { BookingInfo } from '../types';

export const getTableColumns = (
  data: BookingInfo[] | undefined,
  t: (key: string) => string
): ColumnProps[] => {
  return [
    {
      field: 'contenedor',
      header: t('headers.contenedor'), // Translate header
      filter: true,
      showFilterMenu: true,
      sortable: true,
      body: (rowData) => <b>{rowData.contenedor}</b>,
    },
    {
      field: 'viajeCarga',
      header: t('headers.viajeCarga'), // Translate header
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'tipo',
      header: t('headers.tipo'), // Translate header
      filter: true,
      filterElement: (options: ColumnFilterElementTemplateOptions) => (
        <TableDropdownFilter
          options={options}
          data={data as TableData}
          fieldName="tipo"
        />
      ),
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'tamano',
      header: t('headers.tamano'), // Translate header
      filter: true,
      filterElement: (options: ColumnFilterElementTemplateOptions) => (
        <TableDropdownFilter
          options={options}
          data={data as TableData}
          fieldName="tamano"
        />
      ),
      showFilterMenu: true,
      sortable: true,
    },
  ];
};
